import * as React from "react";
import { CalendarClock, ChartLine, MessageSquareHeart } from "lucide-react";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
const features = [{
  title: "Full-Service Oil Changes",
  description: "Premium synthetic and high-mileage oil changes in Jasper, TN. We ensure your engine runs smooth with top-tier filtration and fluid top-offs.",
  icon: CalendarClock,
  badge: "Fast"
}, {
  title: "Tire Sales & Repair",
  description: "Expert tire rotation, balancing, and sales. Keep your vehicle safe on Jasper roads with our professional tire maintenance and repair services.",
  icon: MessageSquareHeart,
  badge: "Popular",
  titleClassName: "@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6 p-6 md:p-8"
}, {
  title: "Fluid & Safety Checks",
  description: "Comprehensive preventative maintenance including brake fluid, coolant, and transmission checks to prevent costly repairs down the road.",
  icon: ChartLine,
  badge: "Fast"
}];
export default function PracticeManagementReimagined() {
  return <section data-section-id="223262" id="our-expert-maintenance-services" className="bg-secondary text-foreground py-24 px-3 md:px-6 overflow-hidden relative">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 rounded-lg blur-[100px] pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold font-default mb-6 tracking-tight uppercase text-primary">
            Our Expert Maintenance Services
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Kimball Speedy Lube & Tires provides the best oil change near you. 
            Our premium-industrial facility in Jasper, TN is equipped for fast, 
            reliable automotive care you can trust.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: false
      }} className="w-full">
          <CarouselContent className="flex flex-col -ml-2 md:-ml-4 md:flex-row">
            {features.map((feature, i) => <CarouselItem key={i} data-index={i} className="pl-3 md:pl-4 basis-full md:basis-1/3">
                <Card className="h-full bg-white border-b-2 border-primary transition-all duration-200 hover:scale-[1.02] hover:shadow-[4px_4px_0px_rgba(0,0,0,0.1)] rounded-md group relative overflow-hidden">
                  <div className="absolute top-4 right-4 bg-destructive text-white text-xs font-bold px-3 py-1 rounded-sm uppercase tracking-wider z-20">
                    {feature.badge}
                  </div>
                  <CardHeader className={`${feature.titleClassName || ""} p-6 md:p-8`}>
                    <div className={`${i === 0 || i === 1 || i === 2 ? "size-40 mx-auto" : "size-14"} rounded-md bg-secondary flex items-center justify-center mb-6 transition-colors duration-200 group-hover:bg-accent`}>
                      {i === 0 ? <img src="https://evident-starfish.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-May-13-2026-12_43_52-PM.png?v=27oaw01r7dp" data-wvc-srcset="https://evident-starfish.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-May-13-2026-12_43_52-PM.png?v=sqmjpwotnqg-wvc-srcset" data-wvc-sizes="https://evident-starfish.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-May-13-2026-12_43_52-PM.png?v=kc13e7y3gx-wvc-sizes" alt="Oil change" className="size-36 object-cover rounded-sm" loading="lazy" decoding="async" /> : i === 1 ? <img src="https://evident-starfish.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-May-13-2026-12_49_09-PM.png?v=z2xj9ary5i" className="size-36 object-cover rounded-sm" alt="Tire service" loading="lazy" /> : <img src="https://evident-starfish.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-May-13-2026-12_51_54-PM.png?v=7dawqz7g6i2" className="size-36 text-destructive" alt="Service icon" />}
                    </div>
                    <CardTitle className={`font-default text-2xl mb-3 font-bold text-primary uppercase ${i === 1 || i === 2 ? "text-center" : ""}`}>
                      {feature.title}
                    </CardTitle>
                    <CardDescription className="text-base leading-relaxed text-muted-foreground font-default">
                      {feature.description}
                    </CardDescription>
                  </CardHeader>
                </Card>
              </CarouselItem>)}
          </CarouselContent>
        </Carousel>
      </div>
    </section>;
}